import ICircuit from "../models/ICircuit";
import { IEvent } from "../models/IEvent";
import { IRiderBest } from "../models/IRider";
import DateHelperInstance from "./DateHelper";
import { axiosInstance } from "./ServiceConstants";
import { v4 as uuidv4 } from 'uuid';
import { CancelToken } from "axios";

class CircuitService {
  async deleteCircuit(circuitId: string) {
      let circuitsDeleteResponse = await axiosInstance.delete(`api/circuits/${circuitId}`);
      if (circuitsDeleteResponse.status>299){
        throw Error(circuitsDeleteResponse.statusText);
      }
  }
  async getBests(circuitId: string, eventType: string, cancelToken?: CancelToken) {
    let circuitBestsResponse = await axiosInstance.get<IRiderBest[]>(
      `api/circuits/${circuitId}/${eventType}/bests`,
      { cancelToken }
    );
    return circuitBestsResponse.data;
  }

  async getEvents(
    circuitId: string,
    start?: Date,
    end?: Date,
    cancelToken?: CancelToken
  ): Promise<IEvent[]> {
    let query = `api/circuits/${circuitId}/events`;
    let dateQuery: string = "";
    if (start) {
      dateQuery = `?from=${start.toISOString()}`;
    }
    if (end) {
      if (dateQuery.length > 0) {
        dateQuery += `&to=${end.toISOString()}`;
      } else {
        dateQuery = `?to=${end.toISOString()}`;
      }
    }
    if (dateQuery.length > 0) {
      query += dateQuery;
    }

    let eventsResponse = await axiosInstance.get<IEvent[]>(query, { cancelToken });
    return eventsResponse.data;
  }
  async getCircuit(circuitId: string, cancelToken?: CancelToken): Promise<ICircuit> {
    let circuitResponse = await axiosInstance.get<ICircuit>(
      `api/circuits/${circuitId}`,
      { cancelToken }
    );
    return circuitResponse.data;
  }
  async getCircuits(cancelToken?: CancelToken): Promise<ICircuit[]> {
    let circuitResponse = await axiosInstance.get<ICircuit[]>(`api/circuits`, { cancelToken });
    return circuitResponse.data;
  }

  async upsertCircuit(circuit: ICircuit): Promise<ICircuit> {
    let circuitResponse = await axiosInstance.post<ICircuit>("api/circuits", {
      ...circuit,
      circuitId: circuit.circuitId ?? uuidv4(),
      lowerThreshold: DateHelperInstance.formatTimeOnly(circuit.lowerThreshold),
      higherThreshold: DateHelperInstance.formatTimeOnly(circuit.higherThreshold)
    });
    return circuitResponse.data;
  }

  async getTimeZones(): Promise<string[]> {
    let timeZonesResponse = await axiosInstance.get<string[]>(
      "api/info/timezones"
    );
    return timeZonesResponse.data;
  }
  async searchCircuits(search: string): Promise<ICircuit[]> {
    let circuitResponse = await axiosInstance.get<ICircuit[]>(
      `api/circuits/search?term=${search}`
    );
    return circuitResponse.data;
  }
}

const CircuitServiceInstance = new CircuitService();

export default CircuitServiceInstance;